import { z } from 'zod';
/**
 * Atreus maneja dinero en **centavos** (integer) para evitar errores de float.
 * Moneda por defecto COP (pesos colombianos). El schema permite extenderse a otras monedas luego.
 */
export const cents = z.number().int().min(0);
export const currencyCode = z.enum(['COP', 'USD', 'MXN', 'PEN', 'ARS']);
export const money = z.object({ amount: cents, currency: currencyCode });
export const formatCOP = (amountCents) => {
    const pesos = amountCents / 100;
    return pesos.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
/** Basis points: 1900 = 19% (IVA general Colombia). */
export const basisPoints = z.number().int().min(0).max(10_000);
export const applyRate = (amount, rateBp) => Math.round((amount * rateBp) / 10_000);
//# sourceMappingURL=index.js.map